/*
** 스크립트 정의
*/
const searchOverlayModule = {
  init: function() {
    this.search_toggle()
  },
  search_toggle: function () {

    const _ = this;
    const html = document.querySelector('html')
    const btns = document.querySelectorAll('.search-overlay-toggle-btn');
    const overlay = document.querySelector('.search-overlay');
    if (html && overlay) {
      btns.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!overlay.classList.contains('search-overlay-is-open')) {
            html.classList.add('has-modal-open');
            overlay.classList.add('search-overlay-is-open');
          } else {
            html.classList.remove('has-modal-open');
            overlay.classList.remove('search-overlay-is-open');
          }
        })
      });

      // 외부 클릭
      overlay.addEventListener('click', (event) => {
        if (event.target.classList.contains('search-overlay')) {
          _.close_search_toggle(html, overlay);
        }
      })

      // 키보드 이벤트 ESC
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          _.close_search_toggle(html, overlay);
        }
      });
    }

  },
  close_search_toggle: function (html, overlay) {
    html.classList.remove('has-modal-open');
    overlay.classList.remove('search-overlay-is-open');
  }
};
searchOverlayModule.init();